import { render, staticRenderFns } from "./fileCopy.vue?vue&type=template&id=d4ebfc86&scoped=true&"
import script from "./fileCopy.vue?vue&type=script&lang=js&"
export * from "./fileCopy.vue?vue&type=script&lang=js&"
import style0 from "./fileCopy.vue?vue&type=style&index=0&id=d4ebfc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebfc86",
  null
  
)

export default component.exports